export enum VideoType {
  VIMEO = 'Vimeo',
  YOUTUBE = 'YouTube',
}

const videoTypeUrls = {
  [VideoType.VIMEO]: 'https://player.vimeo.com/video',
  [VideoType.YOUTUBE]: 'https://www.youtube.com/embed',
};

type VideoUrlParams = {
  title?: boolean;
  playsinline?: boolean;
  // sets video to autoplay, loop, mute
  background?: boolean;
  autoplay?: boolean;
  mute?: boolean;
  controls?: boolean;
};

export const getVideoUrl = (videoType: VideoType, videoId: string, params: VideoUrlParams) => {
  let paramsString = '';
  if (params) {
    for (const [key, value] of Object.entries(params)) {
      paramsString = paramsString ? `${paramsString}&${key}=${value}` : `?${key}=${value}`;
    }
  }

  return `${videoTypeUrls[videoType]}/${videoId}${paramsString}`;
};

export const getVideoId = (url: string) => {
  const videoId = url.split('/').pop();

  return videoId;
};
